// @flow

import React from "react";
// $FlowFixMe
import { ReactComponent } from "./logo.svg";

export default (props: any) => <ReactComponent {...props} />;
